import React from 'react'
import '../styles/Editor.css'
const UserMangAdd = () => {
  return (
    <header className='headerEditor'>
      <h2>
        Add a new UserMang
        </h2>
    </header>
  )
}

export default UserMangAdd